import { createRequestToken } from '@castleio/castle-js';

const createCastleRequestToken = () =>
  new Promise((resolve) => {
    if (window.CASTLE?.enabled) {
      createRequestToken().then(
        (requestToken) => resolve(requestToken),
        () => resolve('')
      );
    } else {
      resolve('');
    }
  });

export default createCastleRequestToken;
